import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from "@cinch-labs/design-system";
import { undashifyAndCapitalise } from "@cinch-labs/shared-util";
import { formatFullSlugToPath } from "@cinch-nx/landing-ui-articles";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import Link from "next/link";
import { ArticlePreviewCard } from "../article-preview-card/article-preview-card";
import styles from "./articles-preview.module.css";
export const ArticlesPreview = ({ slug , articles  })=>{
    const { trackEvent  } = useAnalytics((state)=>({
            trackEvent: state.trackEvent
        }));
    const handleGuideLinkClick = ()=>{
        trackEvent({
            eventName: undashifyAndCapitalise(slug),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "link",
                    label: "guides",
                    action: EventNames.click
                }
            }
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: styles["container"],
        "data-testid": `feature-article-${slug}`,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                element: "h2",
                className: styles["title"],
                children: undashifyAndCapitalise(slug)
            }),
            /*#__PURE__*/ _jsxs("ul", {
                className: styles["articlesList"],
                children: [
                    /*#__PURE__*/ _jsx(ArticlePreviewCard, {
                        title: articles[0].content.title,
                        path: formatFullSlugToPath(articles[0].full_slug),
                        image: articles[0].content.image,
                        date: articles[0].first_published_at ?? "",
                        featured: true
                    }, articles[0].content._uid),
                    /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsxs("ul", {
                            children: [
                                articles.slice(1).map((article)=>/*#__PURE__*/ _jsx(ArticlePreviewCard, {
                                        title: article.content.title,
                                        path: formatFullSlugToPath(article.full_slug),
                                        image: article.content.image,
                                        date: article.first_published_at ?? ""
                                    }, article.content._uid)),
                                /*#__PURE__*/ _jsx("li", {
                                    className: styles["listLink"],
                                    "data-testid": `article-sub-hub-link-${slug}`,
                                    children: /*#__PURE__*/ _jsx(Link, {
                                        href: `/guides/${slug}`,
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ _jsxs("a", {
                                            className: styles["link"],
                                            href: "/guides",
                                            onClick: handleGuideLinkClick,
                                            children: [
                                                /*#__PURE__*/ _jsxs("span", {
                                                    className: styles["linkTitle"],
                                                    children: [
                                                        "All ",
                                                        slug.replace(/-/g, " "),
                                                        " articles"
                                                    ]
                                                }),
                                                "→"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
